// Copyright (c) 2026 Comsearch, Inc., All rights reserved

import { epochToYYYYMMDDinEST } from 'helpers/timeConversion'
import { castToString } from 'helpers/reduxFormFunctions'

const ebandDataForForm = pathData => ({
  ebandLinkConstructionDate: epochToYYYYMMDDinEST(pathData.ebandLinkConstructionDate) || '',
  ebandLinkRegistrationDate: epochToYYYYMMDDinEST(pathData.ebandLinkRegistrationDate) || '',
  ebandLinkRegistrationNumber: castToString(pathData.ebandLinkRegistrationNumber),
  ebandLinkRegistrationStatus: castToString(pathData.ebandLinkRegistrationStatus),
})

export default ebandDataForForm
